/* eslint-disable import/order */
const get = require('lodash/get');

const { PARAMS_TO_PRESERVE } = require('../../app/constants');

const searchApiClient = require('../client/restclient')({
  timeout: process.env.NODE_ENV === 'production' ? 5000 : 5000,
  baseURL: '/',
  retry: {
    maxRetries: 1,
    delay: 0,
  },
});

/**
 * Preserves specific parameters during redirects.
 *
 * @param {string} originalURL - Original request URL
 * @param {string} redirectURL - Redirect URL
 * @returns {string} Redirect URL with preserved parameters
 */
const preserveParamsInRedirect = (originalURL, redirectURL) => {
  try {
    const originalUrl = new URL(originalURL, 'http://localhost');
    const redirectUrl = new URL(redirectURL);

    PARAMS_TO_PRESERVE.forEach((param) => {
      const paramValue = originalUrl.searchParams.get(param);

      if (paramValue && !redirectUrl.searchParams.has(param)) {
        redirectUrl.searchParams.set(param, paramValue);
      }
    });

    return redirectUrl.toString();
  } catch (error) {
    return redirectURL;
  }
};

const createRedirectHandler = (requestURL) => {
  const addRedirectToResponse = ({ data, request, headers }) => {
    const isJSON = get(headers, 'content-type', '').indexOf('application/json') > -1;
    const responseURL = get(request, 'responseURL', '');
    const isValidRedirection = !isJSON && responseURL.indexOf(requestURL) === -1;

    if (!isValidRedirection) {
      return { data, redirect: null };
    }

    const redirectWithPreservedParams = preserveParamsInRedirect(requestURL, responseURL);

    return { data, redirect: redirectWithPreservedParams };
  };

  return addRedirectToResponse;
};

const { SEARCH_MAPS_BASE_PATH } = require('../constants/paths');

class Service {
  static getSearchData({ pathname, search = '' }, requestOptions = {}) {
    const url = `${pathname}${search}`;
    const addRedirectToResponse = createRedirectHandler(url);

    return searchApiClient
      .get(`${SEARCH_MAPS_BASE_PATH}${url}`, {
        headers: {
          Encoding: 'UTF-8',
          'Content-Type': 'application/json',
        },
        ...requestOptions,
      })
      .then(addRedirectToResponse);
  }
}

module.exports = Service;
